/**
 * Stable CSS class names for E2E — Design Collective list, filters, grid & drawer trigger.
 */
export const DCOL = {
    page: 'design-collective-page',
    filtersRow: 'design-collective-page__filters-row',
    fieldDateRange: 'design-collective-field--date-range',
    dateRangeWrap: 'design-collective-page__date-range-wrap',
    fieldStatus: 'design-collective-field--status',
    inputSelectStatus: 'design-collective-input--select-status',
    filterActions: 'design-collective-page__filter-actions',
    inputIconButtonApplyFilter: 'design-collective-input--icon-button-apply-filter',
    inputIconButtonExport: 'design-collective-input--icon-button-export',
    datagridWrap: 'design-collective-page__datagrid',
    inputIconButtonRowDetail: 'design-collective-input--icon-button-row-detail',
} as const;

export const dcolCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
